export default "__VITE_ASSET__CzQHig25__"